/* ==========================================================================
   SearcherFerryHotel > Client > Store > Actions
   ========================================================================== */

/* Types */
const DESTROY = 'SEARCHER_FERRY_HOTEL_RXJS::DESTROY';
const SET_DATA = 'SEARCHER_FERRY_HOTEL_RXJS::SET_DATA';
const CHANGE_DATA = 'SEARCHER_FERRY_HOTEL_RXJS::CHANGE_DATA';

const SET_VEHICLE = 'SEARCHER_FERRY_HOTEL_RXJS::SET_VEHICLE';
const CHANGE_VEHICLE = 'SEARCHER_FERRY_HOTEL_RXJS::CHANGE_VEHICLE';

const SET_ERROR = 'SEARCHER_FERRY_HOTEL_RXJS::ERROR';
const REMOVE_ERROR = 'SEARCHER_FERRY_HOTEL_RXJS::REMOVE_ERROR';
const OPEN_PANEL = 'SEARCHER_FERRY_HOTEL_RXJS::OPEN_PANEL';
const CLOSE_PANEL = 'SEARCHER_FERRY_HOTEL_RXJS::CLOSE_PANEL';
const LOCK = 'SEARCHER_FERRY_HOTEL_RXJS::LOCK';
const UNLOCK = 'SEARCHER_FERRY_HOTEL_RXJS::UNLOCK';

/* Actions */
const destroy = () => ({ type: DESTROY });
const setData = payload => ({ type: SET_DATA, payload });
const changeData = payload => ({ type: CHANGE_DATA, payload });

const setVehicle = payload => ({ type: SET_VEHICLE, payload });
const changeVehicle = payload => ({ type: CHANGE_VEHICLE, payload });

const openPanel = payload => ({ type: OPEN_PANEL, payload });
const closePanel = payload => ({ type: CLOSE_PANEL, payload });
const setError = payload => ({ type: SET_ERROR, payload });
const removeError = () => ({ type: REMOVE_ERROR });

const lock = () => ({ type: LOCK });
const unlock = () => ({ type: UNLOCK });

/* Exports */
module.exports = {
    types: {
        SET_DATA,
        CHANGE_DATA,
        SET_VEHICLE,
        CHANGE_VEHICLE,
        SET_ERROR,
        REMOVE_ERROR,
        OPEN_PANEL,
        CLOSE_PANEL,
        LOCK,
        UNLOCK,
        DESTROY
    },
    actions: {
        setData,
        changeData,
        setVehicle,
        changeVehicle,
        setError,
        removeError,
        openPanel,
        closePanel,
        lock,
        unlock,
        destroy
    }
};
